import {
  getDefaultListToDo,
  addTodo,
  deleteTodo,
  changeStatusTodo,
  updateTodo,
} from "./toDoAction";

const allStore = {
  getDefaultListToDo,
  addTodo,
  deleteTodo,
  changeStatusTodo,
  updateTodo,
};
export default allStore;
